import { useTranslation } from 'react-i18next'
import { EasyPaySubmittedLayout } from 'containers/Premiums/components/EasyPaySubmittedLayout'
import { MyInternalLink, MyLink } from 'components/MyLink'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useLegacyPremiumsHref } from 'hooks/useLegacyPremiumsHref'
import { useEvent } from 'hooks/useEvent'

export const ViewWaysToPayPremiumsLink: React.FC = ({ children }: { children?: React.ReactNode }) => {
  const flags = useFlags()
  const legacyPremiumsHref = useLegacyPremiumsHref()
  const { fireEvent } = useEvent('premiumsEasyPay')

  if (flags?.useNewPremiumsPay) {
    return (
      <MyInternalLink to="/premiums/dashboard" onClick={(params) => fireEvent('premiums_easypaystopsuccess_otherwaystopay_click', params)}>{children}</MyInternalLink>
    )
  }

  return (
    <MyLink href={legacyPremiumsHref} onClick={(params) => fireEvent('premiums_easypaystopsuccess_otherwaystopay_click', params)}>
      {children}
    </MyLink>
  )
}

export function EasyPayStopSuccessPage () {
  const { t } = useTranslation('easyPayStopSuccessPage')

  return (
    <EasyPaySubmittedLayout
      t={t}
      whatNextBulletComponents={{
        link1: <ViewWaysToPayPremiumsLink />
      }}
      pageType='easypaystopsuccess'
    />
  )
}

export default EasyPayStopSuccessPage
